export interface DonationSettings {
  amounts: number[];
  min: number;
  max: number;
}

// Country specific donation amounts and limits
const donationConfig: Record<string, DonationSettings> = {
  GERMANY: {
    amounts: [25, 50, 75, 100],
    min: 5,
    max: 2500,
  },
  NORWAY: {
    amounts: [300, 500, 850, 1000],
    min: 50,
    max: 30000,
  },
  SWEDEN: {
    amounts: [300, 500, 800, 1000],
    min: 50,
    max: 30000,
  },
};

export function getDonationSettings(country: string): DonationSettings {
  return donationConfig[country] || donationConfig['SWEDEN'];
}
